// lib/avatar-url.lib.ts

import { getPublicEnvVars } from './env.lib';

export const getAvatarUrl = (path: string) => {
  if (!path || path.trim() === '') {
    return null;
  }

  return cloudinaryV1Url(path) || cloudinaryOdinUrl(path) || s3Url(path);
};

const cloudinaryV1Url = (path: string): string | null => {
  if (!path.includes('odin')) {
    return cloudinaryParse(`v1/${path}`);
  }
  return null;
};

const cloudinaryOdinUrl = (path: string): string | null => {
  if (/odin\/(homolog|production)\/.{3}\//.test(path)) {
    return cloudinaryParse(path);
  }
  return null;
};

const cloudinaryParse = (url: string): string =>
  `${getPublicEnvVars().PUBLIC_CLOUDINARY_HOST_URL}${url}`;

const s3Url = (path: string): string =>
  `${s3AvatarHost()}/${path.replace(/^\//, '')}`;

const s3AvatarHost = (): string =>
  getPublicEnvVars().PUBLIC_ASSET_DOWNLOAD_URL as string;
